export function Input({ ...props }) {
  return (
    <input className="w-full border px-3 py-2 rounded-md text-sm" {...props} />
  );
}
